import { createContext, ReactNode, useMemo, useState } from 'react';
import { LayoutObjectTemplateContextType } from '../types/context';
import { LayoutObject } from '../types/types';

const defaultValues: LayoutObjectTemplateContextType = {
  isProvided: false,
  template: null,
  rememberObject: () => {
    throw new Error('rememberObject must be implemented');
  },
};

export const LayoutObjectTemplateContext =
  createContext<LayoutObjectTemplateContextType>(defaultValues);

interface LayoutObjectTemplateProviderProps {
  children: ReactNode;
}

// Remembers the last selected canvas object (surviving a later deselection) as
// the template for newly added objects — they inherit its colors, font and
// size. Kept above LayoutEditorProvider, so the memory also survives the
// fullscreen reference route round-trip.
const LayoutObjectTemplateProvider = ({
  children,
}: LayoutObjectTemplateProviderProps) => {
  const [template, setTemplate] = useState<LayoutObject | null>(null);

  const value: LayoutObjectTemplateContextType = useMemo(
    () => ({
      isProvided: true,
      template,
      rememberObject: setTemplate,
    }),
    [template]
  );

  return (
    <LayoutObjectTemplateContext.Provider value={value}>
      {children}
    </LayoutObjectTemplateContext.Provider>
  );
};

export default LayoutObjectTemplateProvider;
